// interact with the alert dialog when active
document.addEventListener('DOMContentLoaded', () => {
    const alertshow = document.querySelectorAll('.alert-show');

    if (alertshow) {
        const alertdialog = document.getElementById('alert-modal');
        const alertclose = document.getElementById('alert-close');

        // backdrop (for when showModal isn't available)
        const backdrop = document.createElement('div');
        backdrop.setAttribute('class', 'backdrop');

        // create a function to set the alert cookies to closed
        const setClosed = () => {
            // call forEach array method on the HTMLCollection
            [].forEach.call(alertdialog.children, child => {
                setCookie(child.id, "closed", 1)
            })
        }

        // open and close the modal
        alertshow.forEach( (a)=> {
            a.addEventListener('click', (e) => {
                e.preventDefault();
                // if there's no showModal, we gotta display the backdrop manually
                if (!'showModal' in alertdialog) {
                    alertdialog.show();
                    alertdialog.parentNode.insertBefore(backdrop, alertdialog.nextSibling);
                } else {
                    alertdialog.showModal();
                }
                return false;
            });
        });

        // note, this covers primary and polyfill behavior
        alertclose.addEventListener('click', (e) => {
            e.preventDefault();
            alertdialog.close();
            // if there's a backdrop element after closing the modal, we gotta remove it
            const bdEl = document.querySelector('.alert + .backdrop');
            if (bdEl) {
                bdEl.remove();
            }
            setClosed();
            return false;
        });

        // if any existing alerts don't have an associated "closed" cookie, open the dialog immediately
        // call forEach array method on the HTMLCollection
        [].forEach.call(alertdialog.children, child => {
            if (!getCookie(child.id)) {
                // if there's no showModal but there is a show, we gotta display backdrop manually
                if (!'showModal' in alertdialog && 'show' in alertdialog) {
                    alertdialog.show();
                    alertdialog.parentNode.insertBefore(backdrop, alertdialog.nextSibling);
                } else if ('showModal' in alertdialog && !alertdialog.open) {
                    alertdialog.showModal();
                }
            }
        })
    }
})
